import { testIsEmptyFilter } from '~/evifields/src/utils/testIsEmptyFilter';
import { SearchFilter } from '~/types/DashboardV2';
import { QueryOperatorEntity } from '~/types/OpenSearch';

import { SearchFilterRecord, SearchQuery } from '../types';
import { toEntity } from '../utils/filters';
import { testIsQueryBuilderOperator } from './QueryBuilder.utils';
import { QueryGroup } from './types';

export const mapFiltersAndOperators = (
  value: QueryGroup['value'],
  searchFilters: Record<string, SearchFilter>,
) => {
  const operator = value.operator;
  const fields = value.filters.filter((f: any) => !testIsEmptyFilter(f));

  const results = fields.reduce((acc: any[], v: any) => {
    const searchFilter = searchFilters[v.fieldId];
    const filter = toEntity(v, searchFilter.type);
    if (operator) {
      return acc.concat(filter, operator);
    } else {
      return acc.concat(filter);
    }
  }, []);

  if (results[results.length - 1]?.type === 'operator') {
    results.pop();
  }
  return results;
};

export const buildQueryWithQueryBuilder = (
  queryBuilder: (QueryGroup | QueryOperatorEntity)[],
  searchFilters: SearchFilterRecord,
): SearchQuery => {
  if (!queryBuilder?.length) return [];

  const result: any = [];
  queryBuilder.forEach((qb) => {
    if (testIsQueryBuilderOperator(qb)) {
      result.push(qb);
    } else {
      const section = {
        type: 'section',
        value: mapFiltersAndOperators(qb.value, searchFilters),
      };
      return result.push(section);
    }
    return result;
  });

  return [...result.flat()];
};
